import { SET_COMPANY_DETAILS, SET_COMPANIES, RESET_COMPANIES, SET_SPECIFIC_COMPANY, RESET_SPECIFIC_COMPANY } from "../Types/CompanyTypes";

const initialState = {
  companyDetails: [],
  specificCompany: null,
  allCompanies: [],
};

const CompanyReducer = (state = initialState, action) => {
  if (action.type === SET_COMPANY_DETAILS) {
    return { ...state, companyDetails: action.payLoad };
  } else if (action.type === SET_COMPANIES) {
    return { ...state, allCompanies: action.payLoad };
  } else if (action.type === RESET_COMPANIES) {
    return { ...state, allCompanies: [] };
  } else if (action.type === SET_SPECIFIC_COMPANY) {
    return { ...state, specificCompany: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_COMPANY) {
    return { ...state, specificCompany: null };
  } else {
    return state;
  }
};

export default CompanyReducer;
